export const AVATAR_COLORS = [
  'linear-gradient(145deg,#c85e20,#f0a060)',
  'linear-gradient(145deg,#7a3a8a,#ba7aca)',
  'linear-gradient(145deg,#3a7ca5,#7ec8e3)',
  'linear-gradient(145deg,#1e3e2b,#4fa472)',
];

export function initialsOf(name) {
  return (
    String(name || '')
      .split(' ')
      .filter(Boolean)
      .map((w) => w[0])
      .slice(0, 2)
      .join('')
      .toUpperCase() || '?'
  );
}

/* "Mohit Rai" → "Mohit R." — the short form used in the topbar/sidebar. */
export function shortNameOf(fullName) {
  const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '';
  return parts.length > 1 ? `${parts[0]} ${parts[parts.length - 1][0]}.` : parts[0];
}

/* Resolves a display avatar for any name — a known parent keeps their assigned
   color; unknown names (e.g. public sign-up volunteers) get a stable hashed one. */
export function avatarFor(name, parents = []) {
  const p = parents.find((x) => x.name.toLowerCase() === String(name || '').toLowerCase());
  if (p) return { initials: p.initials, color: p.color };
  const initials = initialsOf(name);
  let hash = 0;
  for (let i = 0; i < String(name || '').length; i++) hash = (hash * 31 + String(name).charCodeAt(i)) >>> 0;
  return { initials, color: AVATAR_COLORS[hash % AVATAR_COLORS.length] };
}
